<template>
  <div>
    <el-cascader
      v-if="!onlyshow"
      v-model="val"
      :props="{ expandTrigger: 'hover' }"
      :options="props"
      @change="change"
    ></el-cascader>
    <div v-else>
      {{ showStr }}
    </div>
  </div>
</template>
<script>
import are from "@/components/are.js";
/**
 * 根据地区code获得城市的列表
 */
function getACodeList(code, level) {
  const li = [];
  if (are[code]) {
    for (const key in are[code]) {
      const element = are[code][key];
      const th = {
        value: key.toString(),
        label: element
      };
      // console.log('temp对象', th, key)
      if (level < 3) {
        const temp = getACodeList(key, level + 1);
        if (temp.length > 0) {
          th.children = temp;
        }
      }
      li.push(th);
    }
  }
  return li;
}
export default {
  props: {
    onlyshow: {
      default: false,
      type: Boolean
    },
    value: {
      type: Array
    }
  },
  data() {
    return {
      val: [], // v-model 的绑定
      // 返回地理位置
      props: []
    };
  },
  computed: {
    // 显示的字符串
    showStr() {
      let srr = "";
      if (this.value[0]) {
        srr += are[86][this.value[0].toString()];
      }
      if (this.value[1]) {
        srr += are[this.value[0].toString()][this.value[1].toString()];
      }
      if (this.value[2]) {
        srr += are[this.value[1].toString()][this.value[2].toString()];
      }
      return srr;
    }
  },
  watch: {
    value(val) {
      this.val = this.value;
      console.log("地址修改", val, this.val);
    }
  },
  mounted() {
    this.val = this.value;
    const li = getACodeList(86, 1);
    this.props = li;
  },
  methods: {
    // 修改事件
    change(e) {
      this.$emit("input", e);
    }
  }
};
</script>
